module.exports = __webpack_public_path__ + "media/images/making-long-cb52e1514fe0aa017a8987854372252f.jpg";